@if (guideService.isOpen()) {
  <div class="c-guide-backdrop" (click)="guideService.closeGuide()" aria-hidden="true"></div>

  <aside class="c-guide-drawer" cdkTrapFocus [cdkTrapFocusAutoCapture]="true" role="dialog" aria-modal="true" aria-label="Manual de Regras de Negócio WFM e FAQ">
    <!-- 1. HEADER EXECUTIVO MADERO LUXURY -->
    <header class="c-guide-header">
      <div class="c-guide-header__brand">
        <div class="c-guide-logo-m" aria-hidden="true">M</div>
        <div class="c-guide-header__titles">
          <div class="c-guide-header__tag-row">
            <span class="c-guide-header__badge">Ajuda Interativa WFM</span>
            <span class="c-guide-header__kbd">F1</span>
          </div>
          <h3 class="c-guide-title">Central de Regras & FAQ</h3>
          <span class="c-guide-subtitle">Grupo Madero • Gestão de Escalas & Conformidade CLT</span>
        </div>
      </div>
      <button
        type="button"
        class="c-guide-close-btn"
        (click)="guideService.closeGuide()"
        title="Fechar manual (ESC)"
        aria-label="Fechar"
      >
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <!-- 2. ABAS SUPERIORES -->
    <nav class="c-guide-tabs">
      <button
        type="button"
        class="c-guide-tab"
        [class.c-guide-tab--active]="guideService.activeTab() === 'context'"
        (click)="guideService.activeTab.set('context')"
      >
        <mat-icon class="c-guide-tab__icon">visibility</mat-icon>
        <span>Como Funciona Esta Tela</span>
      </button>
      <button
        type="button"
        class="c-guide-tab"
        [class.c-guide-tab--active]="guideService.activeTab() === 'faq'"
        (click)="guideService.activeTab.set('faq')"
      >
        <mat-icon class="c-guide-tab__icon">quiz</mat-icon>
        <span>Dúvidas Frequentes</span>
        <span class="c-guide-tab__counter">{{ guideService.faqList.length }}</span>
      </button>
      <button
        type="button"
        class="c-guide-tab"
        [class.c-guide-tab--active]="guideService.activeTab() === 'all-modules'"
        (click)="guideService.activeTab.set('all-modules')"
      >
        <mat-icon class="c-guide-tab__icon">apps</mat-icon>
        <span>Todas as Telas</span>
      </button>
    </nav>

    <!-- 3. BARRA DE BUSCA UNIVERSAL -->
    <div class="c-guide-search">
      <mat-icon class="c-guide-search__icon" aria-hidden="true">search</mat-icon>
      <input
        type="text"
        name="guideSearchInput"
        aria-label="Pesquisar regras de negócio, CLT ou FAQ"
        class="c-guide-search__input"
        placeholder="Pesquisar regra CLT, interjornada, Pearson, 18 parâmetros, férias, ponto…"
        [ngModel]="guideService.activeSearch()"
        (ngModelChange)="guideService.activeSearch.set($event)"
      />
      @if (guideService.activeSearch()) {
        <button
          type="button"
          class="c-guide-search__clear"
          (click)="guideService.activeSearch.set('')"
          title="Limpar busca"
          aria-label="Limpar busca"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>

    <!-- 4. CORPO DO DRAWER -->
    <div class="c-guide-body">
      @if (guideService.activeTab() === 'context') {
        @if (guideService.currentModule(); as currentModule) {
          <section class="c-guide-hero">
            <div class="c-guide-hero__header">
              <div class="c-guide-hero__icon-wrap">
                <mat-icon class="c-guide-hero__icon">{{ currentModule.icon }}</mat-icon>
              </div>
              <div class="c-guide-hero__info">
                <span class="c-guide-hero__audience">Alçada: {{ currentModule.targetAudience }}</span>
                <h4 class="c-guide-hero__title">{{ currentModule.title }}</h4>
                <p class="c-guide-hero__subtitle">{{ currentModule.subtitle }}</p>
              </div>
            </div>
            <p class="c-guide-hero__overview">{{ currentModule.overview }}</p>
          </section>

          <section class="c-guide-section">
            <div class="c-guide-section__header">
              <div class="c-guide-section__title-group">
                <mat-icon class="c-guide-section__icon">rule</mat-icon>
                <h5 class="c-guide-section__title">Regras de Negócio Aplicadas</h5>
              </div>
              <span class="c-guide-section__badge">{{ guideService.filteredRules().length }} tópicos</span>
            </div>

            <div class="c-guide-rules-list">
              @for (rule of guideService.filteredRules(); track rule.question) {
                <article
                  class="c-guide-rule-card"
                  [class.c-guide-rule-card--warning]="rule.type === 'warning'"
                  [class.c-guide-rule-card--tip]="rule.type === 'tip'"
                >
                  <div class="c-guide-rule-card__top">
                    <span
                      class="c-guide-badge"
                      [class.c-guide-badge--warning]="rule.type === 'warning'"
                      [class.c-guide-badge--tip]="rule.type === 'tip'"
                    >
                      {{ rule.badge || 'Regra WFM' }}
                    </span>
                    <h6 class="c-guide-rule-card__question">{{ rule.question }}</h6>
                  </div>
                  <p class="c-guide-rule-card__answer">{{ rule.answer }}</p>
                </article>
              }
              @if (guideService.filteredRules().length === 0) {
                <div class="c-guide-empty">
                  <mat-icon class="c-guide-empty__icon">search_off</mat-icon>
                  <p class="c-guide-empty__text">Nenhuma regra encontrada para "{{ guideService.activeSearch() }}".</p>
                </div>
              }
            </div>
          </section>

          @if (currentModule.shortcuts.length > 0) {
            <section class="c-guide-section">
              <div class="c-guide-section__header">
                <div class="c-guide-section__title-group">
                  <mat-icon class="c-guide-section__icon">keyboard</mat-icon>
                  <h5 class="c-guide-section__title">Atalhos de Produtividade</h5>
                </div>
              </div>

              <div class="c-guide-shortcuts-grid">
                @for (shortcut of currentModule.shortcuts; track shortcut.trigger) {
                  <div class="c-guide-shortcut">
                    <span class="c-guide-shortcut__key">{{ shortcut.trigger }}</span>
                    <span class="c-guide-shortcut__desc">{{ shortcut.description }}</span>
                  </div>
                }
              </div>
            </section>
          }
        }
      }

      @if (guideService.activeTab() === 'faq') {
        <div class="c-guide-categories">
          @for (cat of guideService.faqCategories(); track cat) {
            <button
              type="button"
              class="c-guide-cat-pill"
              [class.c-guide-cat-pill--active]="guideService.selectedFaqCategory() === cat"
              (click)="setCategory(cat)"
            >
              {{ cat === 'all' ? 'Todas as Dúvidas' : cat }}
            </button>
          }
        </div>

        <section class="c-guide-faq-list">
          @for (item of guideService.filteredFaq(); track item.id) {
            <div class="c-faq-card" [class.c-faq-card--expanded]="isFaqExpanded(item.id)">
              <button
                type="button"
                class="c-faq-card__trigger"
                (click)="toggleFaq(item.id)"
                [attr.aria-expanded]="isFaqExpanded(item.id)"
              >
                <div class="c-faq-card__trigger-main">
                  <span class="c-faq-card__category">{{ item.category }}</span>
                  <h5 class="c-faq-card__question">{{ item.question }}</h5>
                  <p class="c-faq-card__summary">{{ item.summary }}</p>
                </div>
                <mat-icon class="c-faq-card__chevron">
                  {{ isFaqExpanded(item.id) ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              </button>

              @if (isFaqExpanded(item.id)) {
                <div class="c-faq-card__body">
                  <div class="c-faq-card__explanation">
                    <span class="c-faq-card__section-label">
                      <mat-icon>info</mat-icon> Entenda a regra:
                    </span>
                    <p>{{ item.explanation }}</p>
                  </div>

                  @if (item.verificationSteps.length > 0) {
                    <div class="c-faq-card__steps">
                      <span class="c-faq-card__section-label c-faq-card__section-label--steps">
                        <mat-icon>checklist</mat-icon> Passo a passo na plataforma:
                      </span>
                      <ol class="c-faq-steps-list">
                        @for (step of item.verificationSteps; track step) {
                          <li class="c-faq-step-item">
                            <span class="c-faq-step-item__bullet">{{ step.substring(0, 2) }}</span>
                            <span class="c-faq-step-item__text">{{ step.substring(2) }}</span>
                          </li>
                        }
                      </ol>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </section>
      }

      @if (guideService.activeTab() === 'all-modules') {
        <div class="c-guide-modules-grid">
          @for (key of guideService.moduleKeys; track key) {
            <button
              type="button"
              class="c-guide-module-card"
              [class.c-guide-module-card--active]="guideService.selectedModuleKey() === key"
              (click)="selectModule(key)"
            >
              <div class="c-guide-module-card__icon-wrap">
                <mat-icon>{{ guideService.catalog[key].icon }}</mat-icon>
              </div>
              <div class="c-guide-module-card__info">
                <h5 class="c-guide-module-card__title">{{ guideService.catalog[key].title }}</h5>
                <p class="c-guide-module-card__desc">{{ guideService.catalog[key].subtitle }}</p>
                <div class="c-guide-module-card__footer">
                  <span class="c-guide-module-card__count">{{ guideService.catalog[key].rules.length }} regras</span>
                  <span class="c-guide-module-card__action">Ver regras →</span>
                </div>
              </div>
            </button>
          }
        </div>
      }
    </div>

    <!-- 5. RODAPÉ DO DRAWER -->
    <footer class="c-guide-footer">
      <div class="c-guide-footer__hint">
        <span>Pressione</span>
        <kbd>ESC</kbd>
        <span>para fechar a qualquer momento</span>
      </div>
      <div class="c-guide-footer__brand">
        <span class="c-guide-footer__brand-m">M</span>
        <span class="c-guide-footer__brand-text">Workforce Grupo Madero</span>
      </div>
    </footer>
  </aside>
}
